<template>
  <article data-component="CardResult">
    <AtomLink :url="url" class="block cursor-pointer group">
      <h2 class="c-card-result-header font-medium text-app-primary-1-red--torch underline transform transition duration-200 group-hover:text-app-primary-1-red--fire-brick mb-1">
        {{ title }}
      </h2>
      <time v-if="when" class="font-medium" :datetime="when.toISOString()">{{ $d(when, 'long-date') }}</time>
      <template v-if="body">
        <div v-if="stripTags(body).length < 150" v-html="body" />
        <div v-else v-html="truncate(stripTags(body), { length: 150 })" />
      </template>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
import { stripTags, truncate } from '@zicht/nuxt-util'

defineProps({
  url: { type: String, required: true },
  title: { type: String, required: true },
  body: { type: String, required: false, default: undefined },
  when: { type: Date, required: false, default: undefined },
})
</script>

<style scoped>
.c-card-result-header {
  text-underline-offset: 2px;
  text-decoration-thickness: 2px;
}
</style>
